import React, {useEffect, useState} from "react";
import clsx from "clsx";
import {WithOrganization} from "../components/organizations/organization-context";
import {makeStyles} from "@material-ui/core";
import {Navigate, useNavigate} from "react-router-dom";
import {run, useQuery} from "../utils/function-util";
import {getTopFolders} from "../api/pro-guest-functions";
import {FoldersBrowser} from "../components/folders-browser/FoldersBrowser";
import {ProGuestOverview} from "../components/pro-guest/ProGuestOverview";

const useStyles = makeStyles(theme => ({
    proGuestsView: {
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            display: 'block'
        }
    },
    foldersOverview: {
        width: '100%'
    }
}));

export const ProvidersAndGuests: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const query: any = useQuery();
    const navigate = useNavigate();
    const folderIdParam = parseInt(query.get('folderId'));
    const tabIdParam = query.get('tabId') ? parseInt(query.get('tabId')) : 0;
    const [folderId, setFolderId] = useState(folderIdParam);
    const [tabId, setTabId] = useState(tabIdParam);

    useEffect(() => {
        if (folderId !== folderIdParam) {
            setFolderId(folderIdParam);
        }
    }, [folderIdParam]);

    useEffect(() => {
        if (tabId !== tabIdParam) {
            setTabId(tabIdParam);
        }
    }, [tabIdParam]);

    useEffect(run(async () => (currentOrganization && (!folderId || isNaN(folderId))) ? getTopFolders(currentOrganization?.id) : Promise.resolve([]),
        (tops: any) => {
            if (!folderId || isNaN(folderId)) {
                if (tops && tops[0]) {
                    setFolderId(tops[0].id);
                } else {
                    navigate(`/organizations`);
                }
            }
        }), [folderId, currentOrganization]);

    if (!currentOrganization)
        return <Navigate to={'/organizations?returnUrl=/pro-guests'} replace={false}/>;


    const onFolderIdChanged = (newFolderId: any) => {
        if (newFolderId && (newFolderId !== folderId)) {
            setFolderId(newFolderId);
            navigate(`/pro-guests?folderId=${newFolderId}&tabId=${tabId}`);
        }
    };

    return (<div className={clsx(classes.proGuestsView)}>
        {!isNaN(folderId) &&
        <React.Fragment>
            <div>
                <FoldersBrowser
                    folderId={folderId}
                    onFolderIdChanged={onFolderIdChanged}
                />
            </div>
            <div className={clsx(classes.foldersOverview)}>
                <ProGuestOverview
                    tab={tabId}
                    organizationId={currentOrganization.id}
                    folderId={folderId}
                />
            </div>
        </React.Fragment>
        }
    </div>)
};
